import React from 'react';

import { Add } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import CenteredGrid from 'components/CenteredGrid/CenteredGrid';
import ColoredButton from 'components/ColoredButton';
import action_library_messages from 'messages/action_library_messages';
import { useConfirmationModalContext } from 'reactContext/ConfirmationModalContext/ConfirmationModalContext';

import useStyles from './ActionTemplateStepsActions.styles';

type ActionTemplateStepsActionsProps = {
  onAddStep: () => void;
  onCancel: () => void;
  loading: boolean;
  showChecklistError: boolean;
  isEditMode: boolean;
  onSaveAndContinue?: () => void;
  onConfirmSaveAndPublish?: () => void;
};

const ActionTemplateStepsActions: React.FC<ActionTemplateStepsActionsProps> = ({
  onAddStep,
  onCancel,
  loading,
  showChecklistError,
  isEditMode = false,
  onSaveAndContinue,
  onConfirmSaveAndPublish,
}) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const { showConfirmationModal } = useConfirmationModalContext();

  const handleSaveAndPublishClick = async () => {
    const confirmed = await showConfirmationModal({
      body: t(action_library_messages.steps.save_and_publish_confirm_body),
      title: t(action_library_messages.steps.save_and_publish_confirm_title),
    });
    if (confirmed && onConfirmSaveAndPublish) {
      onConfirmSaveAndPublish();
    }
  };

  return (
    <CenteredGrid className={styles.stickyContainer} width='lg' withoutPadding>
      <div className={styles.actionsContainer}>
        <ColoredButton
          className={showChecklistError ? styles.addStepButtonError : styles.addStepButton}
          customColor='secondary'
          disabled={false}
          icon={false}
          onClick={onAddStep}
          showLoader={false}
          startIcon={<Add />}
          textLike={false}
          variant='outlined'
        >
          {t(action_library_messages.steps.add_step)}
        </ColoredButton>
        {isEditMode && (
          <ColoredButton
            className=''
            customColor='grey'
            disabled={loading}
            icon={false}
            onClick={onCancel}
            showLoader={false}
            textLike={false}
            variant='outlined'
          >
            {t(action_library_messages.steps.cancel)}
          </ColoredButton>
        )}
        <ColoredButton
          className=''
          customColor='secondary'
          disabled={loading}
          icon={false}
          onClick={onSaveAndContinue}
          showLoader={loading}
          textLike={false}
          variant='outlined'
        >
          {t(action_library_messages.steps.save_template)}
        </ColoredButton>
        <ColoredButton
          className=''
          customColor='secondary'
          disabled={loading}
          icon={false}
          onClick={handleSaveAndPublishClick}
          showLoader={loading}
          textLike={false}
          type='button'
          variant='outlined'
        >
          {t(action_library_messages.steps.update_template)}
        </ColoredButton>
      </div>
    </CenteredGrid>
  );
};

export default ActionTemplateStepsActions;
